import "./Terms.css";
import { NavLink } from "react-router-dom";
import { useState } from "react";
import { Helmet } from "react-helmet-async";
import logo from "../../components/images/logo.png";

const createSlug = (name) => {
  return name
    ?.toLowerCase()
    .trim()
    .replace(/\s+/g, "")
    .replace(/[^a-z0-9]/g, "");
};

const Terms = ({ Teams, handlePage, dark }) => {
  const [filterType, setFilterType] = useState("all");

  const [searchTerm, setSearchTerm] = useState("");

  const filteredTeams = (Teams || [])
    .filter((team) => {
      if (filterType === "clubs") {
        return team?.metadata?.team?.national === false;
      }
      if (filterType === "international") {
        return team?.metadata?.team?.national === true;
      }
      return true;
    })
    .filter((team) => {
      return team?.name?.toLowerCase().includes(searchTerm.toLowerCase());
    });

  const tabStyle = (type) => ({
    color: dark ? "#f5f5f5ff" : "#3e3f3f",
    cursor: "pointer",
    fontWeight: filterType === type ? "bold" : "normal",
    padding: "6px 12px",
    borderRadius: "6px",
    backgroundColor:
      filterType === type ? (dark ? "#333333ff" : "#e6e6e6") : "transparent",
    transition: "0.2s ease",
  });

  return (
    <>
      <Helmet>
        <title>Football Teams | Clubs & National Teams | Goal Arena</title>

        <meta
          name="description"
          content="Browse football teams from around the world including club sides and national teams. Search teams, explore profiles, players, fixtures and more on Goal Arena."
        />

        <meta
          name="keywords"
          content="football teams, soccer clubs, national teams, premier league clubs, team directory, football club profiles, Goal Arena"
        />

        <meta property="og:title" content="Football Teams | Goal Arena" />

        <meta
          property="og:description"
          content="Explore club teams and international football teams. Search and discover your favorite teams on Goal Arena."
        />

        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://yourdomain.com/teams" />

        <meta
          property="og:image"
          content="https://fadasports.com/static/media/mobilelogo.d0257d49e02d3094cce0.png"
        />

        <meta name="twitter:card" content="summary_large_image" />

        <meta name="twitter:title" content="Football Teams | Goal Arena" />

        <meta
          name="twitter:description"
          content="Search clubs and national football teams from around the world."
        />

        <meta name="twitter:image" content="https://yourdomain.com/logo.png" />

        <link rel="canonical" href="https://yourdomain.com/teams" />
      </Helmet>

      <div className="homer">
        <div className="teamWrapper">
          <h1 className="title" style={dark ? { color: "#fafafaff" } : {}}>
            Team
          </h1>

          <section className="tabs">
            <ul>
              <li onClick={() => setFilterType("all")} style={tabStyle("all")}>
                All
              </li>

              <li
                onClick={() => setFilterType("clubs")}
                style={tabStyle("clubs")}>
                Clubs
              </li>

              <li
                onClick={() => setFilterType("international")}
                style={tabStyle("international")}>
                international
              </li>
            </ul>
          </section>

          <nav>
            <div className="search">
              <input
                type="text"
                placeholder="Search"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={
                  dark
                    ? {
                        backgroundColor: "#333333ff",
                        color: "white",
                      }
                    : { backgroundColor: "white" }
                }
              />
            </div>
          </nav>

          <section className="firstsection">
            {filteredTeams.map((team, index) => {
              const slug = createSlug(team.name);
              const teamUrl = `${slug}-${team?.api_id}`;

              return (
                <NavLink key={index} to={`/teams/${teamUrl}`}>
                  <div
                    onClick={() => handlePage(team)}
                    style={dark ? { backgroundColor: "#333333ff" } : {}}>
                    <img src={team.logo} alt={team.name} />
                    <nav>
                      <p style={dark ? { color: "#fafafaff" } : {}}>
                        {team.name}
                      </p>
                      <small style={dark ? { color: "#d3d0d0ff" } : {}}>
                        {team.country}
                      </small>
                    </nav>
                  </div>
                </NavLink>
              );
            })}
          </section>
        </div>

        <section
          className="addsection"
          style={
            dark
              ? { backgroundColor: "#111111ff", color: "#fff" }
              : { backgroundColor: "whitesmoke" }
          }>
          <div className="clubteam">
            <h1>The Club Teams Resumes its Training in Preparation</h1>
            <p>Watch your favorite team compete in real-time...</p>
          </div>
        </section>
      </div>
    </>
  );
};

export default Terms;
